var _circle, _path, _g, _path2, _g2, _g3, _path3, _g4, _path4, _g5, _g6, _path5, _g7, _g8, _g9, _path6, _path7, _g10, _path8, _g11, _g12, _g13, _path9, _path10, _g14, _path11, _path12, _g15, _path13, _g16, _g17, _path14, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlacierProtocol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30.3334,
    r: 24.5,
    stroke: "url(#paint0_linear_101_22559)",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0242 25.8739L16.7052 18.088L50.4009 18.1359L44.7138 31.5363L37.7091 53.0797L32.7101 35.4293L27.0242 25.8739Z",
    fill: "url(#paint1_linear_101_22559)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 25.9052L16.6987 18.131L50.4924 18.1788L42.3142 31.5592L37.7578 53.1149L31.9415 35.4463L26.5263 25.9052Z",
    fill: "url(#paint2_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6269 25.778L26.6518 25.7976L26.6674 25.8251L32.0826 35.3662L32.0905 35.3802L32.0956 35.3955L37.7237 52.4923L42.1555 31.5256L42.1613 31.4983L42.1758 31.4746L50.2034 18.3406L17.166 18.2939L26.6269 25.778Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter1_b_101_22559)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 25.9052L16.6987 18.131L50.4924 18.1788L42.3142 31.5592L37.7578 53.1149L31.9415 35.4463L26.5263 25.9052Z",
    fill: "url(#paint3_linear_101_22559)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8488 30.5756L13.6127 18.1302L46.0221 18.178L39.7432 25.0714L34.9822 43.9513L27.5087 58.6665L23.4801 40.5319L20.8488 30.5756Z",
    fill: "url(#paint4_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.989 30.4941L21 30.513L21.0056 30.5341L23.6369 40.4904L23.637 40.4904L23.6384 40.4967L27.569 58.1897L34.8293 43.894L39.586 25.0317L39.5959 24.9922L39.6233 24.9621L45.6555 18.3397L13.8949 18.2929L20.989 30.4941Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3187 15.0784L18.1343 18.1768H50.534L45.7776 12.8249L37.6635 4.18909L33.9305 11.2757L28.3187 15.0784Z",
    fill: "url(#paint5_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3659 15.2335L28.3893 15.2264L28.4097 15.2126L34.0215 11.41L34.0551 11.3872L34.074 11.3513L37.701 4.46589L45.6579 12.9344L50.1728 18.0146H19.2247L28.3659 15.2335Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4156 15.0813L16.588 18.1861H50.4832L43.2629 12.8232L37.6471 4.21436L31.8308 11.2708L26.4156 15.0813Z",
    fill: "url(#paint6_linear_101_22559)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4156 15.0813L16.588 18.1861H50.4832L43.2629 12.8232L37.6471 4.21436L31.8308 11.2708L26.4156 15.0813Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 30.5468L13.577 18.0887L48.1664 18.1365L41.4652 25.0369L36.3839 43.9362L27.4306 58.6665L24.108 40.5133L21.2998 30.5468Z",
    fill: "url(#paint7_linear_101_22559)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 30.5468L13.577 18.0887L48.1664 18.1365L41.4652 25.0369L36.3839 43.9362L27.4306 58.6665L24.108 40.5133L21.2998 30.5468Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7104 13.2163L13.4662 18.1855H35.8574L32.6963 10.1745H30.3254L27.3779 2L23.3447 9.24087L20.7104 13.2163Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7642 13.2946L20.7794 13.2842L20.7896 13.2687L23.4239 9.29336L23.4241 9.29352L23.4277 9.28711L27.3593 2.22863L30.2361 10.2067L30.2587 10.2695H30.3254H32.6316L35.7177 18.0905H13.7728L20.7642 13.2946Z",
    stroke: "url(#paint8_radial_101_22559)",
    strokeWidth: 0.19005
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1977 13.2107L13.489 18.1775H48.1679L41.3265 15.4074L36.2544 7.87266L27.3874 2L24.0009 9.23731L21.1977 13.2107Z",
    fill: "url(#paint9_linear_101_22559)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7104 13.2163L13.4662 18.1855H46.0549L39.6259 15.414L34.8595 7.87555L27.3777 2L23.3446 9.24087L20.7104 13.2163Z",
    fill: "url(#paint10_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8021 13.35L20.8281 13.3322L20.8456 13.3058L23.4798 9.33046L23.4802 9.33073L23.4863 9.3198L27.427 2.24491L34.7374 7.98586L39.4888 15.5007L39.5156 15.5431L39.5617 15.5629L45.269 18.0233H13.9894L20.8021 13.35Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7104 13.2163L13.4662 18.1855H46.0549L39.6259 15.414L34.8595 7.87555L27.3777 2L23.3446 9.24087L20.7104 13.2163Z",
    fill: "url(#paint11_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8021 13.35L20.8281 13.3322L20.8456 13.3058L23.4798 9.33046L23.4802 9.33073L23.4863 9.3198L27.427 2.24491L34.7374 7.98586L39.4888 15.5007L39.5156 15.5431L39.5617 15.5629L45.269 18.0233H13.9894L20.8021 13.35Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7104 13.2163L13.4662 18.1855H35.8574L32.6963 10.1745H30.3254L27.3779 2L23.3447 9.24087L20.7104 13.2163Z",
    fill: "url(#paint12_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8022 13.35L20.8282 13.3322L20.8456 13.3058L23.4799 9.33047L23.4803 9.33073L23.4864 9.3198L27.3462 2.39025L30.1729 10.2295L30.2115 10.3367H30.3254H32.5859L35.619 18.0233H13.9894L20.8022 13.35Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter10_b_101_22559)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7104 13.2163L13.4662 18.1855H35.8574L32.6963 10.1745H30.3254L27.3779 2L23.3447 9.24087L20.7104 13.2163Z",
    fill: "url(#paint13_linear_101_22559)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.467 30.5459L18.1343 18.0878L37.7082 18.0878L34.2392 39.7174L32.1667 39.7174L27.519 58.5763L26.7698 40.5124L24.467 30.5459Z",
    fill: "url(#paint14_linear_101_22559)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8452 30.5756L13.6127 18.1302L35.9676 18.1302L32.8116 38.1936L30.4446 38.1936L27.5018 58.6665L23.4752 40.5319L20.8452 30.5756Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9273 30.5278L20.9338 30.5389L20.9371 30.5513L23.567 40.5076L23.5671 40.5076L23.5679 40.5113L27.4818 58.1379L30.3505 38.1801L30.3623 38.0986L30.4446 38.0986L32.7303 38.0986L35.8564 18.2252L13.7779 18.2253L20.9273 30.5278Z",
    stroke: "url(#paint15_radial_101_22559)",
    strokeWidth: 0.19005
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3168 13.2107L17.9552 18.1775H37.6185L34.8425 10.1705H32.7605L27.3846 2L26.6302 9.23731L24.3168 13.2107Z",
    fill: "url(#paint16_linear_101_22559)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.2013,
    y: 37.7511,
    width: 3.21763,
    height: 0.893785,
    fill: "#FF00E5"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3168 13.2107L17.9552 18.1775H37.6185L34.8425 10.1705H32.7605L27.3846 2L26.6302 9.23731L24.3168 13.2107Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8452 30.5756L13.6127 18.1302L35.9676 18.1302L32.8116 38.1936L30.4446 38.1936L27.5018 58.6665L23.4752 40.5319L20.8452 30.5756Z",
    fill: "white",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter15_b_101_22559)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8452 30.5756L13.6127 18.1302L35.9676 18.1302L32.8116 38.1936L30.4446 38.1936L27.5018 58.6665L23.4752 40.5319L20.8452 30.5756Z",
    fill: "url(#paint17_linear_101_22559)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7865 24.2349L11.3992 18.13L29.9798 18.13L26.0218 28.6748L22.9434 45.6018L19.755 31.7272L16.7865 24.2349Z",
    fill: "url(#paint18_linear_101_22559)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7865 24.2349L11.3992 18.13L29.9798 18.13L26.0218 28.6748L22.9434 45.6018L19.755 31.7272L16.7865 24.2349Z",
    fill: "white",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter17_b_101_22559)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7865 24.2349L11.3992 18.13L29.9798 18.13L26.0218 28.6748L22.9434 45.6018L19.755 31.7272L16.7865 24.2349Z",
    fill: "url(#paint19_linear_101_22559)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2966 24.2026L11.4318 18.0885L31.9441 18.0885L27.9089 28.6492L23.0957 45.4384L22.7434 31.7063L20.2966 24.2026Z",
    fill: "url(#paint20_linear_101_22559)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2966 24.2026L11.4318 18.0885L31.9441 18.0885L27.9089 28.6492L23.0957 45.4384L22.7434 31.7063L20.2966 24.2026Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1124 15.7508L15.631 18.177H31.8979L27.7948 13.9862L22.826 7.3175L22.5817 12.7731L20.1124 15.7508Z",
    fill: "url(#paint21_linear_101_22559)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6821 15.7846L11.2527 18.2201H29.9785L25.9896 14.0133L22.8871 7.26038L19.6738 12.7956L16.6821 15.7846Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.721 15.8713L16.7369 15.8641L16.7493 15.8518L19.741 12.8628L19.7498 12.854L19.756 12.8433L22.8773 7.46659L25.9033 14.053L25.9098 14.0673L25.9207 14.0787L29.7575 18.125H11.6968L16.721 15.8713Z",
    stroke: "url(#paint22_radial_101_22559)",
    strokeWidth: 0.19005
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_b_101_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6821 15.7846L11.2527 18.2201H29.9785L25.9896 14.0133L22.8871 7.26038L19.6738 12.7956L16.6821 15.7846Z",
    fill: "url(#paint23_radial_101_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7485 15.9326L16.7757 15.9204L16.7968 15.8993L19.7885 12.9103L19.8035 12.8953L19.8141 12.877L22.8703 7.61236L25.8422 14.081L25.8534 14.1054L25.8719 14.1249L29.6012 18.0579H12.0106L16.7485 15.9326Z",
    stroke: "white",
    strokeOpacity: 0.01,
    strokeWidth: 0.3244
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter21_b_101_22559)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6821 15.7846L11.2527 18.2201H29.9785L25.9896 14.0133L22.8871 7.26038L19.6738 12.7956L16.6821 15.7846Z",
    fill: "url(#paint24_linear_101_22559)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.394,
    y: 17.7308,
    width: 3.21763,
    height: 0.893785,
    fill: "#E2FFF6"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.0568,
    y: 17.5519,
    width: 2.14508,
    height: 0.893785,
    fill: "#E2FFF6"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.0118,
    y: 17.9984,
    width: 3.21763,
    height: 0.893785,
    fill: "#E2FFF6"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.7013,
    y: 2,
    width: 5.66685,
    height: 0.893785,
    transform: "rotate(37.3164 27.7013 2)",
    fill: "url(#paint25_linear_101_22559)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.0822,
    y: 7.32385,
    width: 3.21763,
    height: 0.893785,
    transform: "rotate(57.6396 23.0822 7.32385)",
    fill: "#E2FFF6"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0222,
    y: 18.0879,
    width: 1.78757,
    height: 0.178757,
    fill: "#E2FFF6"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.9207,
    y: 18.0879,
    width: 1.78757,
    height: 0.178757,
    fill: "#E2FFF6"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4767,
    y: 2.08948,
    width: 1.78757,
    height: 0.0893982,
    transform: "rotate(33.297 27.4767 2.08948)",
    fill: "#E2FFF6"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.838,
    y: 7.32959,
    width: 1.78757,
    height: 0.0893982,
    transform: "rotate(53.6202 22.838 7.32959)",
    fill: "#E2FFF6"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_101_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.1095,
    y: 17.8203,
    width: 3.21763,
    height: 0.893785,
    fill: "#E2FFF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_101_22559",
    x: 12.2642,
    y: 13.6965,
    width: 42.6627,
    height: 43.8529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_101_22559",
    x: 12.2642,
    y: 13.6965,
    width: 42.6627,
    height: 43.8529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_101_22559",
    x: 9.17822,
    y: 13.6957,
    width: 41.2784,
    height: 49.4053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_101_22559",
    x: 13.6998,
    y: -0.245422,
    width: 41.2687,
    height: 22.8568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_101_22559",
    x: 12.1535,
    y: -0.220154,
    width: 42.7642,
    height: 22.8408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_101_22559",
    x: 9.14246,
    y: 13.6541,
    width: 43.4585,
    height: 49.4469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_101_22559",
    x: 9.03174,
    y: -2.43451,
    width: 31.2601,
    height: 25.0544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_101_22559",
    x: 9.03174,
    y: -2.43451,
    width: 41.4577,
    height: 25.0544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_101_22559",
    x: 9.03174,
    y: -2.43451,
    width: 41.4577,
    height: 25.0544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_101_22559",
    x: 9.03174,
    y: -2.43451,
    width: 31.2601,
    height: 25.0544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_101_22559",
    x: 9.03174,
    y: -2.43451,
    width: 31.2601,
    height: 25.0544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_101_22559",
    x: 9.17822,
    y: 13.6957,
    width: 31.2239,
    height: 49.4053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_101_22559",
    x: 29.3777,
    y: 36.9275,
    width: 4.86475,
    height: 2.5409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.411776,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_101_22559",
    x: 13.5207,
    y: -2.43451,
    width: 28.5323,
    height: 25.0465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_101_22559",
    x: 9.17822,
    y: 13.6957,
    width: 31.2239,
    height: 49.4053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_b_101_22559",
    x: 9.17822,
    y: 13.6957,
    width: 31.2239,
    height: 49.4053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_101_22559",
    x: 6.96466,
    y: 13.6955,
    width: 27.4496,
    height: 36.3408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_b_101_22559",
    x: 6.96466,
    y: 13.6955,
    width: 27.4496,
    height: 36.3408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_b_101_22559",
    x: 6.99725,
    y: 13.654,
    width: 29.3814,
    height: 36.2189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_b_101_22559",
    x: 6.81824,
    y: 2.82587,
    width: 27.5948,
    height: 19.8287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_b_101_22559",
    x: 6.81824,
    y: 2.82587,
    width: 27.5948,
    height: 19.8287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_b_101_22559",
    x: 6.81824,
    y: 2.82587,
    width: 27.5948,
    height: 19.8287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.21725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_101_22559",
    x: 28.5705,
    y: 16.9073,
    width: 4.86475,
    height: 2.5409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.411776,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_101_22559",
    x: 11.2332,
    y: 16.7283,
    width: 3.79218,
    height: 2.5409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.411776,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_101_22559",
    x: 35.1883,
    y: 17.1749,
    width: 4.86475,
    height: 2.5409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.411776,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_101_22559",
    x: 26.4626,
    y: 1.30315,
    width: 6.44235,
    height: 5.53982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.348426,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_101_22559",
    x: 21.5037,
    y: 6.5003,
    width: 4.12434,
    height: 4.84339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.411776,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_101_22559",
    x: 29.8322,
    y: 17.8978,
    width: 2.1677,
    height: 0.558812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0950252,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_101_22559",
    x: 35.7307,
    y: 17.8978,
    width: 2.1677,
    height: 0.558812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0950252,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_101_22559",
    x: 27.2376,
    y: 1.89943,
    width: 1.92331,
    height: 1.43613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0950252,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_101_22559",
    x: 22.576,
    y: 7.13954,
    width: 1.5123,
    height: 1.87229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0950252,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_101_22559",
    x: 45.2859,
    y: 16.9968,
    width: 4.86475,
    height: 2.5409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.411776,
    result: "effect1_foregroundBlur_101_22559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_22559",
    x1: 31,
    y1: 5.33337,
    x2: 31,
    y2: 55.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441287,
    stopColor: "#ECE3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508997,
    stopColor: "#8F7D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_22559",
    x1: 32.7134,
    y1: 53.3659,
    x2: 32.7134,
    y2: 18.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5185 54.0655) rotate(-106.112) scale(42.5922 45.7061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6AFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_22559",
    x1: 46.641,
    y1: 51.3407,
    x2: 43.0331,
    y2: 18.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360934,
    stopColor: "#ECE3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523403,
    stopColor: "#8F7D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9643 59.7681) rotate(-103.464) scale(48.7537 44.4343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6AFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3832 3.85488) rotate(126.909) scale(20.3963 39.4213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6AFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_101_22559",
    x1: 32.691,
    y1: 4.139,
    x2: 32.691,
    y2: 18.1861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_101_22559",
    x1: 30.0098,
    y1: 58.9984,
    x2: 30.0098,
    y2: 18.0887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2744 1.56016) rotate(112.413) scale(20.4786 29.0537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2BCFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_101_22559",
    x1: 29.9643,
    y1: 1.86769,
    x2: 29.9643,
    y2: 18.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8305 1.56016) rotate(120.976) scale(22.0805 39.2177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6AFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8305 1.56016) rotate(120.976) scale(22.0805 39.2177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6AFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2744 1.56016) rotate(112.413) scale(20.4786 29.0537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_101_22559",
    x1: 33.3055,
    y1: 2.82081,
    x2: 32.133,
    y2: 18.2816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106596,
    stopColor: "#ECE3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523403,
    stopColor: "#8F7D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_101_22559",
    x1: 27.4335,
    y1: 58.8845,
    x2: 27.4335,
    y2: 18.0878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54178,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71599,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887272,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4082 59.7681) rotate(-99.3367) scale(48.0504 30.9612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2BCFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_101_22559",
    x1: 27.2969,
    y1: 1.91275,
    x2: 27.2969,
    y2: 18.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_101_22559",
    x1: 33.4198,
    y1: 56.6108,
    x2: 26.2696,
    y2: 19.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620828,
    stopColor: "#ECE3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798282,
    stopColor: "#8F7D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_101_22559",
    x1: 20.2265,
    y1: 45.75,
    x2: 20.2265,
    y2: 18.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_101_22559",
    x1: 27.8622,
    y1: 44.2086,
    x2: 23.8643,
    y2: 18.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179601,
    stopColor: "#ECE3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475501,
    stopColor: "#8F7D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_101_22559",
    x1: 23.5137,
    y1: 45.602,
    x2: 23.5137,
    y2: 18.0885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_101_22559",
    x1: 23.3591,
    y1: 7.25894,
    x2: 23.3591,
    y2: 18.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#009CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7828 6.96255) rotate(116.994) scale(14.3865 23.4198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2BCFF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_101_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7828 6.96255) rotate(116.994) scale(14.3865 23.4198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_101_22559",
    x1: 27.8444,
    y1: 7.81617,
    x2: 27.2003,
    y2: 18.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106596,
    stopColor: "#ECE3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523403,
    stopColor: "#8F7D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_101_22559",
    x1: 28.0304,
    y1: 2.36725,
    x2: 32.9577,
    y2: 1.53336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2FFF6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlacierProtocol);
export default __webpack_public_path__ + "static/media/glacier_protocol.c3805a3b6f4b97ac5bfa498be039e230.svg";
export { ForwardRef as ReactComponent };